import { environment } from '../environments/environment';
import { ApiEndpoint } from '../types/api';

export const API_ENDPOINT_NAMES = {
  [ApiEndpoint.core]: environment.awsAPICoreEndpointName,
  [ApiEndpoint.client]: environment.awsAPIEndpointName,
};
